import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { TableOfContents } from './table-of-contents';
import { SaneBlockChakra } from '@components';
import { DocsTemplateContent } from '@types';
import { PageContainer } from '../page-container';
import { useEffect } from 'react';
import { analytics, rudderTrack } from 'pages';
import { useRouter } from 'next/router';

type Props = {
  content: DocsTemplateContent;
};

export function DocsTemplate({ content }: Props): JSX.Element {
  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (router.asPath) {
        analytics.track(`Docs_Page_${content.title} Viewed`, {
          surface: 'Docs',
          location: 'Page'
        });

        rudderTrack(`Docs_Page_${content.title} Viewed`, {
          surface: 'Docs',
          location: 'Page'
        });
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [router.asPath]);

  return (
    <PageContainer>
      <Flex py={12} mx="auto" justify="center" color="var(--primaryTextColor)">
        <Box
          px={{ base: 6, lg: 10 }}
          sx={{
            maxW: 'full',

            // Chakra's `xl` breakpoint; table of contents appears here
            '@media screen and (min-width: 1280px)': {
              maxW: 'container.sm'
            },

            '@media screen and (min-width: 1400px)': {
              maxW: 'container.md'
            }
          }}
        >
          <Heading as="h1" size="h4" mb={3} color="var(--primaryTextColor)">
            {content.title}
          </Heading>

          <Text
            as="h3"
            textStyle="md-normal"
            color="var(--secondaryTextColor)"
            mb={6}
          >
            {content.subtitle}
          </Text>

          <SaneBlockChakra blocks={content.body} />
        </Box>

        <TableOfContents content={content.body} />
      </Flex>
    </PageContainer>
  );
}
